import React, { createContext, useState, useCallback, useContext } from 'react';

let toastId = 0;

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const addToast = useCallback((...args) => {
        const [title, bodyOrType, typeOrUrl, url] = args;
        const id = toastId++;
        
        let toast;
        if (typeof title === 'object') {
            toast = { id, ...title };
        } else {
            // Support both old (message, type) and new (title, body, type, url) signatures
            if (args.length <= 2) {
                toast = { id, message: title, type: bodyOrType || 'info' };
            } else {
                toast = { id, title, body: bodyOrType, type: typeOrUrl || 'info', url };
            }
        }
        
        setToasts((prevToasts) => [...prevToasts, toast]);
    }, []);

    const removeToast = useCallback((id) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, []);

    return (
        <ToastContext.Provider value={{ toasts, addToast, removeToast }}>
            {children}
        </ToastContext.Provider>
    );
};

export const useToasts = () => {
    return useContext(ToastContext);
};
